import React from 'react';

import Card from '@/components/atoms/Card';

export interface CardsWithHeaderProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  footerLeft: React.ReactNode;
  footerRight?: React.ReactNode;
  badge?: React.ReactNode;
}

export default function CardsWithHeader({
  icon,
  title,
  description,
  footerLeft,
  footerRight,
  badge,
}: CardsWithHeaderProps) {
  return (
    <Card
      classNames={{
        root: 'p-0 w-full md:min-w-[262px] dark:border-gray-dark-600 flex flex-col relative text-left h-full',
      }}
    >
      <div className='dark:bg-gray-dark-900 flex flex-col items-start gap-4 p-6 '>
        {icon}
        {title}
      </div>
      <div className='dark:bg-gray-dark-800 flex h-full flex-col justify-between gap-6 p-6'>
        <div className='flex text-gray-500'>{description}</div>
        <div className='flex h-10 items-center justify-between'>
          {footerLeft}
          {footerRight}
        </div>
      </div>
      {badge}
    </Card>
  );
}
